/*
    删除value为空的属性
*/
const getRemoveNullObject = (obj) => {
    let o = JSON.parse(JSON.stringify(obj))
    for(var key in o) {
        if (!o[key]) {
            delete o[key];    
        }
    }
    return o;
}
/*
    jsonparse报错，返回空对象
*/
const getJsonParse = (val) => {
    try{
        return JSON.parse(val);
    } catch(error) {
        return {};
    }
}

function getDeepValue (res,key) {
    res = res || {};
    key = key || '';
    var v = JSON.parse(JSON.stringify(res));
    var flag = true;
    var arr = key.split('.') || [];
    arr.map(function(item,index){
        if (v[item]) {
           v = v[item]
        } else {
           flag = false;
        }
    })
    return {
        flag : flag,
        v : v,
    };
}
/*
    深拷贝方法
*/
const getDeepVal = (res,key,defval) => {
    let {flag=false, v=''} = getDeepValue(res,key);
    return flag ? v : defval;
}

export {
    getRemoveNullObject,
    getJsonParse,
    getDeepVal,
}
